// extracted by mini-css-extract-plugin
export default {"form":"ExportPricelistToPdfModal__form___Sa9RJ","formRow":"ExportPricelistToPdfModal__formRow___OADzU","includeNetPrice":"ExportPricelistToPdfModal__includeNetPrice___S6bVx"};